// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const e = {
  production: true, // Set to true before the production build and deployment
  serverUrl: '',
  rootUrl: '',
  loginUrl: '/login',
  assets: '../../../assets',
  wsEndpoint: '',
  wsReconnectInterval: 2000,
  refreshInterval: 60000,
  stage: 'aerodv',
  apiServiceId: '35mr0s0dui',
  accessKeyId: '',
  secretAccessKey: '',
  column_name: 'Parent Node',
  custom_field: 'subclass_id',
  prod_labels: ['Total', 'Division', 'Department', 'Class'],
  bourneUrl: '',
  region: 'us-east-1',
  cognito: {
    userPoolId: 'us-east-1_aqEzPgZ2M',
    userPoolClientId: '58ehdp6o2rsse6taq0tkokcl9o',
    oauthDomain: 'us-east-1aqezpgz2m.auth.us-east-1.amazoncognito.com',
    redirectSignIn: [
      'http://localhost:4200/',
      'https://aeropostale-dev.sizeo.ai/',
      'https://d1bt5zxkkxhify.cloudfront.net/'
    ],
    redirectSignOut: [
      'http://localhost:4200/logout/',
      'https://aeropostale-dev.sizeo.ai/logout/',
      'https://d1bt5zxkkxhify.cloudfront.net/logout/'
    ]
  },
  appsync: {
    endpoint: 'https://32q6rz76knc45mwb2k3s63f42m.appsync-api.us-east-1.amazonaws.com/graphql'
  }
}

export const environment = e

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
